import { useCallback, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { ClientSelectorPanel } from '@/components/ClientSelector/ClientSelectorPanel.tsx';

type Props = {
  triggerRef: React.RefObject<HTMLButtonElement | null>;
  onSelectClient: (clientId: number) => void;
};

export const ChangeClientDropDownItem = ({ triggerRef, onSelectClient }: Props) => {
  // 💡 State for whether the change account popover is open
  const [opened, setIsOpened] = useState(false);

  const open = useCallback(() => {
    setIsOpened(true);
  }, []);

  const select = (clientId: number) => {
    setIsOpened(false);
    onSelectClient(clientId);
  };

  const close = useCallback(() => {
    setIsOpened(false);
  }, []);

  return (
    <Dropdown.Item onClick={open} data-e2e="change-account-menu">
      <FormattedMessage id="tile.header.menu.changeAccount" />
      {opened && <ClientSelectorPanel triggerRef={triggerRef} onClose={close} onSelectClient={select} />}
    </Dropdown.Item>
  );
};
